function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { COMPLETE_BULK_UPLOAD_FILES_SUCCESS, DELETE_REPORT_SUCCESS, DOWNLOAD_REPORT_SUCCESS, FILE_PARTS_UPLOAD_FAILURE, FILE_PARTS_UPLOAD_REQUEST, FILE_PARTS_UPLOAD_SUCCESS, GET_DOWNLOAD_REPORT_URL_REQUEST, GET_DOWNLOAD_REPORT_URL_SUCCESS, GET_REPORT_DETAILS_SUCCESS, GET_TERM_REPORT_CONFIGS_FAILURE, GET_TERM_REPORT_CONFIGS_REQUEST, GET_TERM_REPORT_CONFIGS_SUCCESS, PREVIEW_ENABLED, RESET_BULK_FILES_PART_STATE, RESET_GET_REPORT_DETAILS, RESET_IS_TRIGGER_SEARCH_REPORT, RESET_REPORT_LIST, SEARCH_REPORTS_REQUEST, SEARCH_REPORTS_SUCCESS, SELECT_LP, SET_CURRENT_FOLDER_PATH, SET_CURRENT_PAGE, SET_FILTER_SHEET_OPEN, SET_FILTERS, SET_REPORT_SELECTION, SET_SEARCH_REPORTS_PAGE_SIZE, SET_SORT_CRITERIA, START_GET_REPORT_DETAILS_POLLING_REQUEST, STOP_GET_REPORT_DETAILS_POLLING_REQUEST, UPLOAD_FILE_FOLDER_SUCCESS } from "../../actions/types";
import { DEFAULT_REPORTS_LIST_PAGE_SIZE } from "../../constants";
import { UPLOAD_STATUS } from "../../constants/upload";
import { DEFAULT_SORT_CRITERIA } from "../../constants/search";
import { DOWNLOAD_TYPE } from "../../constants/download";
export var initialState = {
    reportsList: [],
    reportsListTotalRecords: 0,
    searchReportsPageSize: DEFAULT_REPORTS_LIST_PAGE_SIZE,
    termReportConfigs: null,
    getTermReportConfigsError: false,
    downloadedReport: null,
    lpSelected: "",
    bulkFilesPartsUpload: {},
    isTriggerSearchReport: false,
    currentFolderPath: "",
    currentPage: 1,
    selectedReports: [],
    sortCriteria: DEFAULT_SORT_CRITERIA,
    isPreviewEnabled: false,
    downloadReportPresignedURL: null,
    reportDetails: null,
    filterSheetOpen: false,
    filters: {},
    isGetReportDetailsPolling: false
};
export function reportsCenterReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, _ref = arguments.length > 1 ? arguments[1] : void 0, type = _ref.type, payload = _ref.payload;
    switch(type){
        case SEARCH_REPORTS_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    reportsListTotalRecords: 0
                });
            }
        case SEARCH_REPORTS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    reportsList: payload.reportList,
                    reportsListTotalRecords: payload.totalRecords
                });
            }
        case GET_TERM_REPORT_CONFIGS_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    getTermReportConfigsError: false
                });
            }
        case GET_TERM_REPORT_CONFIGS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    termReportConfigs: payload
                });
            }
        case GET_TERM_REPORT_CONFIGS_FAILURE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    getTermReportConfigsError: true
                });
            }
        case DOWNLOAD_REPORT_SUCCESS:
            {
                var _Object_values;
                var _payload_supportingDocumentUrls;
                if ((payload === null || payload === void 0 ? void 0 : payload.downloadType) === DOWNLOAD_TYPE.SUPPORTING_DOCUMENTS && ((_Object_values = Object.values((_payload_supportingDocumentUrls = payload === null || payload === void 0 ? void 0 : payload.supportingDocumentUrls) !== null && _payload_supportingDocumentUrls !== void 0 ? _payload_supportingDocumentUrls : {})) === null || _Object_values === void 0 ? void 0 : _Object_values.length)) {
                    var _Object_values1;
                    var _payload_supportingDocumentUrls1;
                    (_Object_values1 = Object.values((_payload_supportingDocumentUrls1 = payload === null || payload === void 0 ? void 0 : payload.supportingDocumentUrls) !== null && _payload_supportingDocumentUrls1 !== void 0 ? _payload_supportingDocumentUrls1 : {})) === null || _Object_values1 === void 0 ? void 0 : _Object_values1.forEach(function(downloadUrl, index) {
                        if (payload === null || payload === void 0 ? void 0 : payload.supportingDocumentKey) {
                            var _Object_keys_index, _Object_keys;
                            var _payload_supportingDocumentUrls;
                            if ((_Object_keys = Object.keys((_payload_supportingDocumentUrls = payload === null || payload === void 0 ? void 0 : payload.supportingDocumentUrls) !== null && _payload_supportingDocumentUrls !== void 0 ? _payload_supportingDocumentUrls : {})) === null || _Object_keys === void 0 ? void 0 : (_Object_keys_index = _Object_keys[index]) === null || _Object_keys_index === void 0 ? void 0 : _Object_keys_index.endsWith(payload === null || payload === void 0 ? void 0 : payload.supportingDocumentKey)) {
                                window.open(downloadUrl, "_blank");
                            }
                        } else {
                            window.open(downloadUrl, "_blank");
                        }
                    });
                } else if ((payload === null || payload === void 0 ? void 0 : payload.downloadType) === DOWNLOAD_TYPE.REPORT && (payload === null || payload === void 0 ? void 0 : payload.downloadUrl)) {
                    window.open(payload === null || payload === void 0 ? void 0 : payload.downloadUrl, "_blank");
                }
                return _object_spread_props(_object_spread({}, state), {
                    downloadedReport: payload
                });
            }
        case SELECT_LP:
            {
                return _object_spread_props(_object_spread({}, state), {
                    lpSelected: payload,
                    currentPage: 1,
                    currentFolderPath: "",
                    selectedReports: []
                });
            }
        case RESET_REPORT_LIST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    reportsList: [],
                    reportsListTotalRecords: 0
                });
            }
        case SET_CURRENT_FOLDER_PATH:
            {
                return _object_spread_props(_object_spread({}, state), {
                    currentFolderPath: payload,
                    currentPage: 1,
                    selectedReports: []
                });
            }
        case SET_CURRENT_PAGE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    currentPage: payload,
                    selectedReports: []
                });
            }
        case SET_SEARCH_REPORTS_PAGE_SIZE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    searchReportsPageSize: payload,
                    currentPage: 1
                });
            }
        case FILE_PARTS_UPLOAD_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    bulkFilesPartsUpload: _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload), _define_property({}, payload.key, {
                        status: UPLOAD_STATUS.IN_PROGRESS,
                        uploadId: payload.uploadId,
                        reportId: payload.reportId,
                        supportingDocumentInfo: payload.supportingDocumentInfo,
                        partPresignedURLs: payload.partPresignedURLs,
                        key: payload.key,
                        logisticsPartyId: payload.logisticsPartyId,
                        reportType: payload.reportType,
                        term: payload.term
                    }))
                });
            }
        case FILE_PARTS_UPLOAD_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    bulkFilesPartsUpload: _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload), _define_property({}, payload.key, _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload[payload.key] || {}), {
                        status: UPLOAD_STATUS.SUCCESS,
                        eTags: payload.eTags
                    })))
                });
            }
        case RESET_IS_TRIGGER_SEARCH_REPORT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isTriggerSearchReport: false
                });
            }
        case FILE_PARTS_UPLOAD_FAILURE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    bulkFilesPartsUpload: _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload), _define_property({}, payload.key, _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload[payload.key] || {}), {
                        status: UPLOAD_STATUS.FAILURE
                    })))
                });
            }
        case COMPLETE_BULK_UPLOAD_FILES_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isTriggerSearchReport: true,
                    bulkFilesPartsUpload: {},
                    selectedReports: []
                });
            }
        case RESET_BULK_FILES_PART_STATE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    bulkFilesPartsUpload: {}
                });
            }
        case DELETE_REPORT_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isTriggerSearchReport: true,
                    selectedReports: []
                });
            }
        case UPLOAD_FILE_FOLDER_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isTriggerSearchReport: true,
                    selectedReports: []
                });
            }
        case SET_REPORT_SELECTION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    selectedReports: payload
                });
            }
        case SET_SORT_CRITERIA:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sortCriteria: payload
                });
            }
        case PREVIEW_ENABLED:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isPreviewEnabled: payload
                });
            }
        case GET_DOWNLOAD_REPORT_URL_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    downloadReportPresignedURL: null
                });
            }
        case GET_DOWNLOAD_REPORT_URL_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    downloadReportPresignedURL: payload
                });
            }
        case START_GET_REPORT_DETAILS_POLLING_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isGetReportDetailsPolling: true
                });
            }
        case STOP_GET_REPORT_DETAILS_POLLING_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isGetReportDetailsPolling: false
                });
            }
        case GET_REPORT_DETAILS_SUCCESS:
            {
                var _payload_reportList;
                return _object_spread_props(_object_spread({}, state), {
                    reportDetails: (payload === null || payload === void 0 ? void 0 : (_payload_reportList = payload.reportList) === null || _payload_reportList === void 0 ? void 0 : _payload_reportList.length) ? payload.reportList[0] : null
                });
            }
        case RESET_GET_REPORT_DETAILS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    reportDetails: null
                });
            }
        case SET_FILTER_SHEET_OPEN:
            {
                return _object_spread_props(_object_spread({}, state), {
                    filterSheetOpen: payload
                });
            }
        case SET_FILTERS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    filters: payload
                });
            }
        default:
            {
                return state;
            }
    }
}

//# sourceMappingURL=index.js.map